import { ReactElement } from 'react';

import { Stack } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';

import { logger } from '@/utils';
import { ManageProfile, RecentActivity, Table } from '../components';

// import { FormFields } from '../components';
// import { AccessLoginButton } from '../components';
// import { useLoginForm } from '../hooks';

export const Users = (): ReactElement => {
  const form = useForm();

  const handleSubmit = form.handleSubmit((formData) => logger.log(formData));

  return (
    <FormProvider {...form}>
      <Table />
    </FormProvider>
  );
};
